module.exports = __webpack_public_path__ + "media/images/icons/material/chevron-right-85482290305530a59fd16c8c72bc2e29.svg";